<template>
  <div class="developer-status">
    <v-chip
      :color="statusColor"
      text-color="white"
      small
    >
      {{ availabilityLabel }}
    </v-chip>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: {
    availability: {
      type: Object,
      required: true,
    },
  },

  computed: {
    statusColor() {
      let color;
      switch (this.availability.status) {
        case 'Unavailable':
          color = 'red';
          break;
        case 'Available with limit':
          color = 'orange';
          break;
        case 'Available after the notice period':
          color = 'yellow';
          break;
        case 'No data':
          color = 'grey';
          break;
        default:
          color = 'green';
      }
      return color;
    },

    availabilityLabel() {
      let label;

      if (this.availability.status === 'Available with limit') {
        if (this.availability.from && this.availability.to) {
          label = `From ${this.availabilityDate(this.availability.from)} to ${this.availabilityDate(this.availability.to)}`;
        } else if (this.availability.from) {
          label = `From ${this.availabilityDate(this.availability.from)}`;
        } else if (this.availability.to) {
          label = `To ${this.availabilityDate(this.availability.to)}`;
        }
      } else {
        label = this.availability.status;
      }
      return label;
    },
  },

  methods: {
    availabilityDate(value) {
      return dayjs(value).format('DD.MM.YYYY');
    },
  },

};
</script>
